import { TONE_RULES } from '../../constants/rules';

export class ToneGenerator {
    constructor(templates) {
        this.templates = templates;
    }

    analyzeToneDistribution(globalTone, _partitionsData) {
        let conclusion = "";

        // 基本色调描述
        if (!globalTone?.mainTone?.rules) {
            return this.templates.tones.analysis.noRules;
        }

        const rules = globalTone.mainTone.rules;

        // 添加基本色调描述
        if (rules.mainTone?.length > 0) {
            const toneTemplate = this.templates?.tones?.rules?.mainTone[rules.mainTone[0]];
            if (toneTemplate) {
                conclusion = toneTemplate;
            }
        }

        // 添加强度描述
        if (rules.intensity?.length > 0) {
            const intensityTemplate = this.templates?.tones?.rules?.toneIntensity[rules.intensity[0]];
            if (intensityTemplate) {
                conclusion += conclusion
                    ? this.templates.tones.analysis.conclusion.period + intensityTemplate
                    : intensityTemplate;
            }
        }

        // // 添加范围描述
        // if (rules.range?.length > 0) {
        //     const rangeTemplate = this.templates?.tones?.rules?.toneRange?.[rules.range[0]];
        //     console.log('【色调分析】范围匹配模板:', rules.range[0], rangeTemplate);
        //     if (rangeTemplate) {
        //         conclusion += conclusion ? `，${rangeTemplate}` : rangeTemplate;
        //     }
        // }

        return conclusion;
    }

    generateConclusion(globalData, partitionsData) {
        let conclusions = [];

        // 基本色调分析
        const toneDistribution = this.analyzeToneDistribution(globalData, partitionsData);
        if (toneDistribution) {
            conclusions.push(toneDistribution);
        }

        // 分析整体一致性
        if (TONE_RULES.OVERALL_CONSISTENCY.condition(globalData, partitionsData)) {
            const template = this.templates?.tones?.overallAnalysis?.consistency?.OVERALL_CONSISTENCY;
            if (template) {
                conclusions.push(template);
            }
        }

        // 分析全局-分区差异性
        const variations = TONE_RULES.OVERALL_VARIATIONS.condition(globalData, partitionsData);
        if (variations) {
            let variationDesc = this.templates?.tones?.overallAnalysis?.variations?.OVERALL_VARIATIONS;

            // 添加具体分区差异描述
            const partitionDescs = variations.map(partition => {
                const intensityText = partition.intensity === 'STRONG'
                    ? this.templates.tones.analysis.conclusion.partitionTone.strong
                    : partition.intensity === 'MODERATE'
                        ? this.templates.tones.analysis.conclusion.partitionTone.moderate
                        : '';

                const toneText = partition.tone.includes('RED')
                    ? this.templates.tones.analysis.conclusion.partitionTone.red
                    : partition.tone.includes('GREEN')
                        ? this.templates.tones.analysis.conclusion.partitionTone.green
                        : partition.tone === 'NEUTRAL'
                            ? this.templates.tones.analysis.conclusion.partitionTone.neutral
                            : '';

                // 使用模板中的分区名称映射
                const partitionName = this.templates.mappings.partitions[partition.name];
                return `${partitionName}${intensityText}${toneText}`;
            });

            if (partitionDescs.length > 0) {
                variationDesc += this.templates.tones.analysis.conclusion.separator +
                    this.templates.tones.analysis.conclusion.partitionVariation
                        .replace("${descriptions}", partitionDescs.join(this.templates.tones.analysis.conclusion.separator));
            }

            if (variationDesc) {
                conclusions.push(variationDesc);
            }
        }

        // 明暗分区对比
        if (TONE_RULES.SHADOW_HIGHLIGHT_CONTRAST.condition(globalData, partitionsData)) {
            const template = this.templates?.tones?.overallAnalysis?.contrast?.SHADOW_HIGHLIGHT_CONTRAST;
            if (template) {
                conclusions.push(template);
            }
        }
        let finalConclusion = conclusions.join(this.templates.tones.analysis.conclusion.period);
        // 在最后添加period
        finalConclusion += this.templates.tones.analysis.conclusion.period;
        return finalConclusion || this.templates.tones.analysis.noData;
    }
}